var React = require("react");

var styled = require("styled-components").default;

var Text = require("@patternplate/component-text").Text;

module.exports = styled(function (props) {
  return React.createElement(Text, {
    className: props.className
  }, props.children);
}).withConfig({
  displayName: "tag__exports"
})(["display:inline-block;padding:2px 4px;margin-top:1.5px;margin-bottom:1.5px;color:", ";border:1px solid ", ";border-radius:3px;&:link,&:visited,&:active{text-decoration:none;color:", ";}&:nth-child(2n){margin-left:3px;}"], function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.theme.colors.color;
}, function (props) {
  return props.theme.colors.color;
});
//# sourceMappingURL=index.js.map